module.exports = __webpack_public_path__ + "static/media/joespice.b161a468.png";